import { LuCar, LuCastle, LuCircleDot, LuCircleHelp, LuCoins, LuCrown, LuDice5, LuDices, LuFlag, LuGamepad2, LuGem, LuGrid3X3, LuHouse, LuKey, LuLayers, LuLayoutGrid, LuLocateFixed, LuLockOpen, LuShield, LuShip, LuStar, LuTimer, LuTrophy, LuUsers, LuZap } from "react-icons/lu";

type Ico = (p: { size?: number; "aria-hidden"?: any }) => any;
/** the whole "how do I play" in three pictures and a couple of words each – for a first grader as well as for a ninth grader */
const STEPS: Record<string, [Ico, string][]> = {
  monopoly: [[LuCircleHelp, "Svar"], [LuDices, "Slå terning"], [LuHouse, "Køb og byg"]],
  kortkamp: [[LuLayers, "Læg et kort"], [LuCircleHelp, "Svar på +2"], [LuTrophy, "Tøm hånden"]],
  slagskibe: [[LuCircleHelp, "Svar"], [LuLocateFixed, "Skyd"], [LuShip, "Sænk flåden"]],
  speedrun: [[LuTimer, "Tiden går"], [LuZap, "Svar hurtigt"], [LuStar, "Saml point"]],
  fire: [[LuCircleHelp, "Svar"], [LuCircleDot, "Drop en brik"], [LuTrophy, "Fire på række"]],
  skak: [[LuCircleHelp, "Svar"], [LuCrown, "Flyt en brik"], [LuTrophy, "Skakmat!"]],
  kryds: [[LuCircleHelp, "Svar"], [LuGrid3X3, "Sæt dit mærke"], [LuTrophy, "Tre på række"]],
  quizduel: [[LuUsers, "Samme spørgsmål"], [LuZap, "Svar først"], [LuTrophy, "Flest point"]],
  videnraes: [[LuCircleHelp, "Svar"], [LuFlag, "Ræs frem"], [LuTrophy, "Først i mål"]],
  taarn: [[LuCircleHelp, "Svar for guld"], [LuCastle, "Køb tårne"], [LuShield, "Stop ballonerne"]],
  skattejagt: [[LuCircleHelp, "Svar"], [LuKey, "Find nøglen"], [LuGem, "Åbn kisten"]],
  ludo: [[LuCircleHelp, "Svar"], [LuDices, "Terningen slår"], [LuFlag, "Først i mål"]],
  yatzy: [[LuCircleHelp, "Svar"], [LuDice5, "Slå og behold"], [LuStar, "Skriv point"]],
  sudoku: [[LuCircleHelp, "Svar"], [LuLockOpen, "Åbn en boks"], [LuLayoutGrid, "Fyld tallene"]],
  videnspar: [[LuLayers, "Vend to kort"], [LuCircleHelp, "Svar på et par"], [LuTrophy, "Find alle par"]],
  verden: [[LuCar, "Kør og udforsk"], [LuCircleHelp, "Svar ved stoppene"], [LuFlag, "Vind ræs"]],
};
/** the same idea for the whole site */
const SITE: [Ico, string][] = [[LuGamepad2, "Vælg et spil"], [LuCircleHelp, "Svar"], [LuCoins, "Vind mønter"]];

export function HowTo({ game, big }: { game?: string; big?: boolean }) {
  const s = game ? STEPS[game] : SITE;
  if (!s) return null;
  return (
    <ol className={`howto${big ? " big" : ""}`} aria-label="Sådan spiller du">
      {s.map(([I, t], i) => (
        <li key={i}>
          <span className="ht-ico"><I size={big ? 40 : 32} aria-hidden="true" /><b>{i + 1}</b></span>
          <span className="ht-t">{t}</span>
        </li>
      ))}
    </ol>
  );
}
